import { useContext, useEffect, useState } from "react";
import { ROUTES } from "../../../routes";
import Utils from "../../../utils/utils";
import { HiExclamationCircle, HiX } from "react-icons/hi";
import { Link, useNavigate } from "react-router-dom";
import FGInput from "../../../components/dumb/FGInput";
import usePageTitle from "../../../hooks/use-page-title";
import ApiWLFormat from "../../../modules/api/wl-format";
import ApiProgramme from "../../../modules/api/programme";
import Notifier from "../../../modules/notifier/notifier";
import FGTextarea from "../../../components/dumb/FGTextarea";
import FGDropdownApi from "../../../components/form/FGDropdownApi";
import Debouncer from "../../../modules/debouncer/debouncer";
import Multilingual from "../../../modules/multilingual/multilingual";
import { PortalContext, usePortalSettingSet } from "../../../context/portal-context";
import WLFieldsEditor, {
  WLField,
} from "../../../components/dumb/WLFieldsEditor";
import FooterBoxAction from "../../../components/common/FooterBoxAction";
import ModulePopup from "../../../modules/popup/popup";
import { BsBoxArrowInDown } from "react-icons/bs";

export default function PageWLFormatAdd() {
  const title = "Add New Workplace Learning Report";
  const navigate = useNavigate();
  usePageTitle(title);
  usePortalSettingSet("label_header", title);
  const { setCustomText } = useContext(PortalContext);

  const [contentChanged, setContentChanged] = useState(false);
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    fields: [],
    programme: null,
  });

  useEffect(() => {
    setCustomText(title);
  }, []);

  const handleOnChange = (e: any) => {
    setContentChanged(true);
    setFormData((d) => ({
      ...d,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOnChangeFields = (value: Array<WLField>) => {
    setContentChanged(true);
    setFormData((d) => ({ ...d, fields: value }));
  };

  const showAlertError = (text: string) => {
    ModulePopup.showAlert({
      title: <>
          <HiExclamationCircle />
          Alert
      </>,
      description: <>
          <p>{text}</p>
        </>
    })
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.fields.length) {
      showAlertError('"Sections" is empty. Please add one at least.');
      return;
    }
    if (!formData.programme) {
      showAlertError("Please choose a Programme.");
      return;
    }
    Debouncer.execute("SUBMIT_DATA", async () => {
      setSending(true);
      await ApiWLFormat.create({ ...formData })
        .then(async (res) => {
          setSending(false);
          if (res.result === "OK") {
            Notifier.success(res.message);
            await Utils.sleep(2000);
            navigate(ROUTES.PORTAL_WL_FORMATS);
          } else {
            showAlertError(res.message);
          }
        })
        .catch((error) => {
          setSending(false);
          showAlertError(error.message);
        });
    });
  };

  return (
    <main className="form-generic content-generic">
      {/* <h1 className="fs-title hide-mobile-down">{title}</h1> */}

      {/* <div className="cg__actions hide-mobile-down">
        <Link
          to={ROUTES.PORTAL_WL_FORMATS}
          className="btn btn-primary"
          onClick={(e) => {
            if (
              contentChanged &&
              !window.confirm(Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE"))
            ) {
              e.preventDefault();
            }
          }}
        >
          <HiArrowLeft /> Back
        </Link>
      </div> */}

      <form onSubmit={(e) => {
          e.preventDefault();
          ModulePopup.showAlertConfirm({
            title: "Confirmation",
            description: "Are you sure you want to save the changes?",
            onYes() {
              handleSubmit(e);
            },
          });
      }} className="box-default bg-white p-3">
        <FGInput
          name="name"
          id="name"
          type="text"
          label="Name of Report"
          required
          autoFocus
          onChange={handleOnChange}
        />

        <WLFieldsEditor
          value={formData.fields}
          onChange={handleOnChangeFields}
        />

        <FGTextarea
          name="description"
          id="description"
          label="Description of Report"
          onChange={handleOnChange}
        />

        <FGDropdownApi
          required
          label="Choose a Programme"
          name="programme"
          defaultValue={formData.programme}
          api={ApiProgramme.getOptions}
          onChange={handleOnChange}
        />

        <div>
          <button type="submit" className="btn btn-secondary" disabled={sending}>
            <BsBoxArrowInDown className="icon-pos-upper" /> Save
          </button>{" "}
          <Link
            to={ROUTES.PORTAL_WL_FORMATS}
            className="btn btn-primary"
            onClick={(e) => {
              if (
                contentChanged &&
                !window.confirm(
                  Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE")
                )
              ) {
                e.preventDefault();
              }
            }}
          >
            <HiX /> Cancel
          </Link>
        </div>
      </form>

      <FooterBoxAction backUrl={ROUTES.PORTAL_WL_FORMATS}
        onBackUrlClick={(e) => {
          if (
            contentChanged &&
            !window.confirm(Multilingual.get("CONFIRM_ACTION_CANT_BE_UNDONE"))
          ) {
            e.preventDefault();
          }
        }}
      />
    </main>
  );
}
